import type { PublicPage } from '@makerstack/page-render'

/** Example page shown in the landing-page phone preview. */
export const SAMPLE_PAGE: PublicPage = {
  username: 'damon',
  displayName: 'Damon Chen',
  bio: 'This is how I started indie hacking 👇',
  location: 'Austin, TX',
  social: {
    twitter: 'damengchen',
    github: 'damon',
    youtube: 'https://youtube.com',
  },
  theme: 'indie',
  font: 'inter',
  emailCollection: { enabled: false },
  startups: [
    { name: 'Quit 9–5 from Cisco', tagline: 'The leap that started it all' },
    { name: 'Spent a year building, made $0', tagline: 'Lessons from the wilderness' },
    { name: 'Testimonial.to took off', tagline: 'Collect testimonials on autopilot' },
    { name: 'Acquired Supportman.io', tagline: 'Slack reports for support teams' },
    { name: 'Angel invested in Feather.so', tagline: 'Backing fellow makers' },
    { name: 'Acquired PDF.ai and grew it', tagline: 'Chat with any document' },
  ],
}
